import React from "react"
import classNames from "classnames"
import type { FilterOption } from "./index"
import { FILTER_GROUPS, FILTER_ACTIONS } from "../../constants"

export default function UniverseSearchOption({ option, props, numOptions }: { option: FilterOption, props: React.HTMLAttributes<HTMLLIElement>, numOptions: number }) {
  if (option.group === FILTER_GROUPS.SAVED_SEARCHES) {
    return (
      <li {...props} key={option.value} className="saved-search-option">
        <div className="saved-search-option-content">
          <div className="saved-search-name">
            {option.label} <span className="filter-count">{option.nbFilters} {option.nbFilters === 1 ? "filter" : "filters"} selected</span>
          </div>
          <div className="saved-search-info">
            {option.count} names found as of Today
          </div>
        </div>
      </li>
    )
  }
  return (
    <li {...props} className={classNames("saved-search-option", { "has-divider": option.value === FILTER_ACTIONS.CREATE_CUSTOM_SEARCH && numOptions > 1 })} key={option.value}>
      <div className="saved-search-name"> {option.label} </div>
      {option.description && <div className="saved-search-info">{option.description}</div>}
    </li>
  )
}
